module.exports = __webpack_public_path__ + "media/images/feature/Selecting team-amico-57b06a0b5f86ccd74f846019810a2003.png";